import { render, staticRenderFns } from "./BattleItemButton.vue?vue&type=template&id=bb06a098&scoped=true&"
import script from "./BattleItemButton.vue?vue&type=script&lang=ts&"
export * from "./BattleItemButton.vue?vue&type=script&lang=ts&"
import style0 from "./BattleItemButton.vue?vue&type=style&index=0&id=bb06a098&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb06a098",
  null
  
)

export default component.exports